<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close :loading="loading">
			<template #default>
				<vxe-grid ref="wlncustomerList" v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
				<addForm ref="addForm" @success="addSuccess" />
				<formwindow :formConfig="formModule" v-if="formwindowShow" @back="formBack" />
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="选择" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import addForm from './add.vue'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
			condition: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal_model:false,
				modal_title: '客户列表',
				modal_width:1000,
				modal_height:600,
				loading:false,
				formwindowShow: false,
				formModule: {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					foreingKey: {},
					extra: {},
					windowName: '',
					windowType: 'modal',
					isflow: 0,
					flowprogressid: 0,
					flowid: 0,
				
				},
				list_formConfig: [{
						field: 'condition',
						title: '筛选条件',
						itemRender: {
							name: '$input',	
							defaultValue:this.condition,
							props:{
								placeholder:"输入编码、名称、手机号、昵称、公司"
							}
						}
					},
					{
						field: 'tp_tid',
						title: '单据查找',
						itemRender: {
							name: '$input',	
							props:{
								placeholder:"以订单查找客户"
							}
						}
					}
				],
				list_columns: [
					{
						title: '#',
						type:'radio',
						width:50,
						fixed:'left'
					},
					{
						field: 'code',
						title: '客户编码',
						width:100,
						// treeNode:true
					},
					{
						field: 'customername',
						title: '客户名称',
						width:100,
					},
					{
						field: 'sourceNick',
						title: '昵称',
						width:100,
					},
					{
						field: 'name',
						title: '收件人',
						width:100,
					},
					{
						field: 'staffid',
						title: '业务员',
						width:100,
						formatter:"staff"
					},
					{
						field: 'province',
						title: '省',
						width:50,
					},
					{
						field: 'city',
						title: '市',
						width:50,
					},
					{
						field: 'area',
						title: '区',
						width:50,
					},
					{
						field: 'street',
						title: '街道',
						width:100,
					},
					{
						field: 'address',
						title: '地址',
						width:100,
					},
					{
						field: 'phone',
						title: '手机',
						width:100,
						fixed:'right'
					},
					{
						field: 'account',
						title: '银行账户',
						width:100,
					},
					{
						field: 'bank',
						title: '开户行',
						width:100,
					},
					{
						field: 'title',
						title: '公司名称/收款人',
						width:100,
						fixed:'right'
					},
					{
						field: 'taxid',
						title: '税号',
						width:100,
					},
					{
						field: 'email',
						title: '邮箱',
						width:100,
					},
					{
						field: 'archivecode',
						title: '档案编码',
						width:100,
						// treeNode:true
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 100,
						slots: {
							default: ({row}) => {
								return [
									<el-button type = "text" size = "mini" onClick = {() => {this.edit(row)}}>编辑</el-button>,
									<el-button type = "text" size = "mini" onClick = {() => {this.pull(row)}}>拉取</el-button>
								]
							}
						}
					}					
				]
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				// console.log(gridOptions.formConfig,this.condition)
				gridOptions.formConfig.items.forEach((item)=>{
					if(item.field == 'condition'){
						item.itemRender.defaultValue = this.condition
					}
				})
				// gridOptions.formConfig = false
				gridOptions.pagerConfig = {
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					enabled: true,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20],
				}
				gridOptions.treeConfig = {
					transform: true,
					rowField: 'id',
					parentField: 'parentid',
					line: false,
					expandAll: true,
				}
				gridOptions.radioConfig = {
					trigger: 'row'
				}
				gridOptions.toolbarConfig.buttons =  [{
					name: '新增',
					status: 'primary',
					code: 'add'
				},{
					name: '拉取',
					status: 'success',
					code: 'pull'
				}]
			},
			customerreload(){
				this.$refs.wlncustomerList.commitProxy('query')
			},
			list(page, form, other) {
				// console.log(form)
				// form.condition = form.condition?form.condition:this.condition
				return new Promise((resolve) => {
					this.$api.crmcustomer.listerpcustomer({
						...page,
						...form,
						...other
					}).then((res)=>{
						this.$emit('list',res)
						resolve(res)
					},()=>{
						resolve()
					})
				})
			},
			add(){
				this.$refs.addForm.modal_show()
			},
			addSuccess(){
				this.$refs.addForm.modal_show()
			},
			pull(row){
				this.loading = true
				this.$api.crmcustomer.pull({id:row?row.id:null}).then(()=>{
					this.loading = false
					this.customerreload()
				},()=>{
					this.loading = false
				})
			},
			edit(row){
				this.formModule = {
					name: 'crmcustomer',
					id: row.id,
					controlltype: 2,
					windowName: '编辑客户',
					foreingKey: {},
					extra: {}
				}
				this.formwindowShow = true
			},
			formBack(e) {
				this.formwindowShow = false
				this.formModule = {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					extra: {},
					foreingKey: {},
				}
				if (e.type != 'cancle') {
					this.customerreload()
				}
			},
			submit() {
				let data = this.$refs.wlncustomerList.getRadioRecord()
				this.$emit('submit',{data:data})
				this.modal_model = false
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			addForm
		}
	}
</script>